"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  MonitorProgrammingBook: ['monitor-programming-book', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M2.5,16a.5.5,0,0,1-.5-.5V4.5A.5.5,0,0,1,2.5,4H17.125a.5.5,0,0,1,.5.5V8a1,1,0,0,0,2,0V4a2,2,0,0,0-2-2H2A2,2,0,0,0,0,4V16a2,2,0,0,0,2,2H7.375a.25.25,0,0,1,.25.25v1.5a.25.25,0,0,1-.25.25H5a1,1,0,0,0,0,2h7.625a1,1,0,1,0,0-2H9.875a.25.25,0,0,1-.25-.25V18.226a.25.25,0,0,1,.2-.245,1,1,0,0,0-.2-1.98Z', 'M3.47,9.971a.75.75,0,1,0,1.06,1.06l2-2a.749.749,0,0,0,0-1.06l-2-2a.75.75,0,1,0-1.06,1.06L4.763,8.324a.252.252,0,0,1,0,.354Z', 'M7,11.751H9.125a.75.75,0,0,0,0-1.5H7a.75.75,0,1,0,0,1.5Z', 'M18.25,16.5a.5.5,0,1,1-1,0V11.274a.5.5,0,0,0-.239-.426,8.957,8.957,0,0,0-4.177-1.1,1.2,1.2,0,0,0-1.253,1.2v7.279a1.2,1.2,0,0,0,1.156,1.2,7.082,7.082,0,0,1,4.523,1.593.742.742,0,0,0,.528.218.751.751,0,0,0,.529-.215,7.084,7.084,0,0,1,4.527-1.6A1.2,1.2,0,0,0,24,18.235V10.956a1.208,1.208,0,0,0-.369-.867,1.186,1.186,0,0,0-.886-.337A8.851,8.851,0,0,0,18.48,10.9a.5.5,0,0,0-.23.421Z']],
  ProgrammingBook: ['programming-book', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M3.015,21.059A2.944,2.944,0,0,0,5.956,24H19.015a1.972,1.972,0,0,0,1.97-1.971V5.913a1.972,1.972,0,0,0-1.97-1.971H5.956A.942.942,0,0,1,5.015,3a1,1,0,0,1,1-1h13.47a1,1,0,0,0,0-2H6.015a3,3,0,0,0-3,3Zm9.5-6.4h4a.75.75,0,0,1,0,1.5h-4a.75.75,0,0,1,0-1.5Zm-5.031-3.72a.75.75,0,0,1,1.061-1.06l2.5,2.5a.749.749,0,0,1,0,1.06l-2.5,2.5a.75.75,0,1,1-1.061-1.06L9.277,13.09a.25.25,0,0,0,0-.354Z']],
  ProgrammingFlag: ['programming-flag', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M1.5,24A1.5,1.5,0,0,0,3,22.5v-3.83a.25.25,0,0,1,.165-.235L4.371,18a8.766,8.766,0,0,1,7.381.971A10.33,10.33,0,0,0,20,20.1l2.8-.873A1.655,1.655,0,0,0,24,17.644V4.485A1.652,1.652,0,0,0,21.9,2.9l-2.172.692a9.36,9.36,0,0,1-7.45-1.025A9.779,9.779,0,0,0,4.052,1.5l-.717.261A.25.25,0,0,1,3,1.525V1.5a1.5,1.5,0,0,0-3,0v21A1.5,1.5,0,0,0,1.5,24ZM15.22,8.031a.75.75,0,1,1,1.06-1.06l3,3a.749.749,0,0,1,0,1.06l-3,3a.75.75,0,1,1-1.06-1.06l2.293-2.293a.252.252,0,0,0,0-.354Zm-4.207,6.182a.751.751,0,0,1-.475-.949l2-6a.75.75,0,1,1,1.424.474l-2,6a.751.751,0,0,1-.712.513A.787.787,0,0,1,11.013,14.213ZM5.22,11.031a.749.749,0,0,1,0-1.06l3-3a.75.75,0,0,1,1.06,1.06L6.987,10.324a.252.252,0,0,0,0,.354L9.28,12.971a.75.75,0,1,1-1.06,1.06Z']]
};
exports["default"] = _default;